import React from 'react';
import { Wrapper } from './styles';
import Main from 'features/feature-statistics/components/Main';

const Statistics = () => {
  return (
    <Wrapper>
      <Main />
    </Wrapper>
  );
};

export default Statistics;
